module.exports = "<app-header></app-header>\n\n<!-- corpo che cambia. utente loggato, tipo utente, dashboard, tipo dashboard -->\n<router-outlet></router-outlet>\n<!-- <div class=\"container-fluid logged-in dashboard\"> -->\n\n<app-footer></app-footer>\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/default/default.layout.component.html
// module id = ./src/app/layout/default/default.layout.component.html
// module chunks = main